export const Quality = { // Layout page
  path: '/quality',
  component: () => import('@/View/QA/layout/layout.vue'),
  hidden: true,
  redirect: '/quality/dashboard',
  name: 'Quality',
  meta: {
    title: 'Quality',
    selected: false,
    permissionList: ['abc', 'def']
  },
  children: [
    { // quality dashboard start
      path: '/quality/dashboard',
      component: () => import('@/View/QA/dashboard/dashboard.vue'),
      hidden: false,
      icon: 'dashboard',
      name: 'QADashboard',
      meta: {
        breadCrumb: 'Quality',
        title: 'Dashboard',
        selected: true,
        permissionList: ['abc', 'def']
      }
    },
    { // quality dashboard start
      path: '/quality/activityLog',
      component: () => import('@/View/QA/ActivityLog/ActivityLogs.vue'),
      hidden: false,
      icon: 'fas fa-clock',
      name: 'QAActivityLog',
      meta: {
        breadCrumb: '',
        title: 'ActivityLog',
        selected: true,
        permissionList: ['abc', 'def']
      },
      children: []
    },
    { // ProcessList start
      path: '/quality/process',
      component: () => import('@/View/QA/main/index.vue'),
      hidden: false,
      redirect: {name: 'QAProcessComponent'},
      name: 'QAProcess',
      icon: 'fas fa-code-branch',
      meta: {
        breadCrumb: 'process',
        title: 'Process',
        icon: 'fas fa-code-branch',
        selected: true,
        permissionSlug: 'quality_process',
        permissionList: ['isViewAll']
      },
      children: [
        {
          path: '/quality/process/list',
          component: () => import('@/View/QA/QAProcess/QaProcessList.vue'),
          name: 'QAProcessComponent',
          hidden: true,
          meta: {
            icon: 'fas fa-code-branch',
            title: 'List',
            breadCrumb: 'Process',
            selected: false,
            permissionList: ['isViewAll']
          }
        },
        {
          path: '/quality/process/new:workOrderId',
          component: () => import('@/View/QA/QAProcess/NewQAProcess.vue'),
          name: 'NewProcess',
          hidden: true,
          meta: {
            breadCrumb: 'New Process',
            icon: 'fas fa-code-branch',
            title: 'New Process',
            selected: false,
            permissionList: ['']
          }
        },
        {
          path: '/quality/process/new/report/:qualityResourceId/:reportId',
          component: () => import('@/View/QA/QAProcess/Report/NewReport.vue'),
          name: 'NewQualityReport',
          hidden: true,
          meta: {
            breadCrumb: 'New Report',
            icon: 'fas fa-code-branch',
            title: 'New Report',
            selected: false,
            permissionList: ['']
          }
        },
        {
          path: '/quality/process/report/details/:reportId/:resourceId/:assuranceId',
          component: () => import('@/View/QA/QAProcess/Report/reportDetails.vue'),
          name: 'QAReportDetails',
          hidden: true,
          meta: {
            breadCrumb: 'New Report',
            icon: 'fas fa-code-branch',
            title: 'Report Details',
            selected: false,
            permissionList: ['']
          }
        },
        {
          path: '/quality/process/details/:assuranceId',
          component: () => import('@/View/QA/QAProcess/QAProcessDetails.vue'),
          name: 'ProcessDetails',
          hidden: true,
          meta: {
            breadCrumb: 'Details',
            icon: 'fas fa-code-branch',
            title: 'Details',
            selected: false,
            permissionList: ['']
          }
        }]
    },
    { // Setting object start
      path: '/quality/settings',
      component: () => import('@/View/QA/main/index.vue'),
      hidden: false,
      redirect: {name: 'QualitysettingsComponent'},
      name: 'Qualitysettings',
      icon: 'fa fa-cog',
      meta: {
        breadCrumb: 'settings',
        title: 'Settings',
        icon: 'fa fa-cog',
        selected: true,
        permissionSlug: 'quality_settings',
        permissionList: ['']
      },
      children: [{
        path: 'dashboard',
        component: () => import('@/View/QA/Setting/setting.vue'),
        name: 'QualitysettingsComponent',
        hidden: true,
        meta: {
          icon: 'fa fa-cog',
          title: 'Dashboard',
          selected: false,
          permissionList: ['']
        }
      },
      { // Process List page
        path: 'process',
        component: () => import('@/View/QA/main/index.vue'),
        hidden: false,
        redirect: {name: 'ProcessSettingList'},
        name: 'Process',
        icon: 'fas fa-tools',
        meta: {
          breadCrumb: 'Process',
          title: 'Process',
          icon: 'fas fa-tools',
          color: '#1976d2',
          selected: true,
          permissionList: ['isViewAll'],
          permissionSlug: 'process'
        },
        children: [{
          path: 'list',
          component: () => import('@/View/QA/Setting/Process/ProcessList.vue'),
          name: 'ProcessSettingList',
          meta: {
            breadCrumb: 'Process',
            icon: 'fas fa-tools',
            title: 'Process',
            permissionSlug: 'process'
          }
        }]
      },
      { // Questions List page
        path: 'category',
        component: () => import('@/View/QA/main/index.vue'),
        hidden: false,
        redirect: {name: 'CategoryListC'},
        name: 'CategoryList',
        icon: 'fa fa-question-circle',
        meta: {
          breadCrumb: 'Category',
          title: 'Category',
          color: '#2196f3',
          selected: false,
          permissionList: ['isViewAll'],
          permissionSlug: 'quality_questions'
        },
        children: [{
          path: 'list',
          component: () => import('@/View/QA/Setting/Questions/categoryList.vue'),
          name: 'CategoryListC',
          meta: {
            breadCrumb: 'CategoryList',
            icon: 'fas fa-tools',
            title: 'Category',
            permissionSlug: 'quality_questions'
          }
        },
        {
          path: 'details:categoryId',
          component: () => import('@/View/QA/Setting/Questions/categoryDetails.vue'),
          name: 'QualityCategoryDetail',
          meta: {
            breadCrumb: 'Category Details',
            icon: 'fas fa-tools',
            title: 'Category Details',
            permissionSlug: ''
          }
        },
        {
          path: 'question:questionId:categoryId',
          component: () => import('@/View/QA/Setting/Questions/NewQuestion.vue'),
          name: 'NewQualityQuestions',
          meta: {
            breadCrumb: 'New Question',
            icon: 'fas fa-tools',
            title: 'New Question',
            permissionSlug: ''
          }
        },
        {
          path: 'question/details:QuestionId',
          component: () => import('@/View/QA/Setting/Questions/questiondetails.vue'),
          name: 'QualityQueDetail',
          meta: {
            breadCrumb: 'Question',
            icon: 'fas fa-tools',
            title: 'Question Details',
            permissionSlug: ''
          }
        }]
      }]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/View/QA/router/index.js